<template>
    <page :title="$t('account_myInformation')" :breadcrumb="breadcrumb">
        <div class="row">
            <div class="col-sm-12">
                <h6 class="page-title-small mt-5">{{ $t('account_personalInformation') }}</h6>
                <div class="row">
                    <div class="col-md-4">
                        <div class="form-group" :class="{'has-danger': errors.has('firstname')}">
                            <label for="firstname">{{ $t('account_firstName') }}</label>
                            <input v-model="user.firstname"
                                   v-validate="'required|min:3'"
                                   name="firstname"
                                   :class="{'form-control-danger': errors.has('firstname')}"
                                   id="firstname" type="text" class="form-control">
                            <small class="form-text text-danger" v-if="errors.has('firstname')">
                                {{ errors.first('firstname') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group" :class="{'has-danger': errors.has('middlename')}">
                            <label for="middlename">{{ $t('account_middleName') }}</label>
                            <input v-model="user.middlename"
                                   v-validate="''"
                                   name="middlename"
                                   :class="{'form-control-danger': errors.has('middlename')}"
                                   id="middlename" type="text" class="form-control">
                            <small class="form-text text-danger" v-if="errors.has('middlename')">
                                {{ errors.first('middlename') }}
                            </small>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="form-group" :class="{'has-danger': errors.has('lastname')}">
                            <label for="lastname">{{ $t('account_lastName') }}</label>
                            <input v-model="user.lastname"
                                   v-validate="'required|min:3'"
                                   name="lastname"
                                   :class="{'form-control-danger': errors.has('lastname')}"
                                   id="lastname" type="text" class="form-control">
                            <small class="form-text text-danger" v-if="errors.has('lastname')">
                                {{ errors.first('lastname') }}
                            </small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="preferredlanguage">{{ $t('account_preferredLanguage') }}</label>
                            <select v-model="user.preferredlanguage" class="form-control" id="preferredlanguage">
                                <option v-for="(lang) in languages" :key="lang.id" :value="lang.id">{{ lang.languagename }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group" :class="{'has-danger': errors.has('licenseplate')}">
                            <label for="licenseplate">{{ $t('account_licensePlate') }}</label>
                            <input v-model="user.licenseplate"
                                   v-validate="'required|min:3'"
                                   name="licenseplate"
                                   :class="{'form-control-danger': errors.has('licenseplate')}"
                                   id="licenseplate" type="text" class="form-control">
                            <small class="form-text text-danger" v-if="errors.has('licenseplate')">
                                {{ errors.first('licenseplate') }}
                            </small>
                        </div>
                    </div>
                </div>
                <h6 class="page-title-small mt-5">{{ $t('account_accountInformation') }}</h6>
                <div class="form-group" :class="{'has-danger': errors.has('email')}">
                    <label for="email">{{ $t('account_email') }} / {{ $t('login_login') }}</label>
                    <input v-model="user.email"
                           v-validate="'required|email|min:3'"
                           name="email"
                           :class="{'form-control-danger': errors.has('email')}"
                           id="email" type="text" class="form-control">
                    <small class="form-text text-danger" v-if="errors.has('email')">
                        {{ errors.first('email') }}
                    </small>
                </div>
                <div class="form-group-btn">
                    <button class="btn btn-primary float-right ml-3" @click="update" :disabled="errors.any() || $wait.is('updating')">
                        <i class="fa fa-save" aria-hidden="true"></i>
                        {{ $t('account_updateInformation') }}
                    </button>
                    <button class="btn btn-outline-primary float-right" @click="$router.push({name: 'PasswordChange', params: $route.params})">
                        <i class="fa fa-key" aria-hidden="true"></i>
                        {{ $t('pwd_changePassword') }}
                    </button>
                </div>
            </div>
        </div>
    </page>
</template>

<script>
import Page from './utilities/Page'
import { mapGetters } from 'vuex'
import { API } from '../api/axios'
import * as qs from 'qs'

export default {
  name: 'MyAccount',
  components: {Page},
  computed: {
    ...mapGetters(['user', 'language', 'languages', 'savedQueryParams']),
    breadcrumb () {
      return [
      ]
    },
  },
  methods: {
    update () {
      this.$wait.start('updating')
      let querystring = qs.stringify({
        firstname: this.user.firstname,
        middlename: this.user.middlename,
        lastname: this.user.lastname,
        licenseplate: this.user.licenseplate,
        preferredlanguage: this.user.preferredlanguage,
        email: this.user.email,
      })
      API.put(`/users/${this.user.id}?${querystring}`)
        .then(response => {
          console.log('Updated!', response)
        })
        .then(() => this.$wait.end('updating'))
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/MyAccount.vue